export enum MessageType {
  Sent = 'sent',
  Received = 'received',
}

export interface Message {
  id: string
  text: string
  type: MessageType
  timestamp?: string
  showInputFields?: boolean
}
